import CbayelWorkflowOpinionForm from './workflow-opinion-form';
export default CbayelWorkflowOpinionForm;
